import { motion } from "framer-motion";
import { Globe2, Info, MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import ActionButton from "../utils/ActionButton";
import { Link } from "react-router";
const nonprofits = [
  // {
  //   id: 1,
  //   name: "Bears Ears Partnership",
  //   address: "567 W. Main St. (Highway 191),Bluff, UT 84512",
  //   contact: "435-414-0343",
  //   email: "info@bearsearspartnership.org",
  //   website: "https://bearsearspartnership.org",
  //   mission:
  //     "Protect and build respect for the greater Bears Ears region's cultural and natural resources",
  //   programs: "Conservation, education, stewardship, research, indigenous partnerships",
  //   logo: "/img/nonprofits/bep-logo_primary-inverse.webp",
  // },
  {
    id: 2,
    name: "Columbus Community Center",
    address: "3495 S West Temple, Salt Lake City, UT 84115",
    contact: "801-262-1552",
    email: "mowen@columbusserves.org",
    website: "https://columbusserves.org",
    mission:
      "Enhance lives of people with disabilities via employment, training, day programs, housing",
    programs: "Employment, residential homes, supported living, autism services",
    logo: "/img/nonprofits/CCC-Logo-WHITE.webp",
  },
  {
    id: 3,
    name: "The Children's Center Utah",
    address: "3725 West 4100 South West Valley City, Utah 84120",
    contact: "801-582-5534",
    email: "sgood@tccutah.org, jclark@tccutah.org",
    website: "https://childrenscenterutah.org",
    mission:
      "Help children/families shape futures; champion mental/behavioral health",
    programs: "Outpatient clinical services, therapeutic preschool, training, trauma-informed care",
    logo: "/img/nonprofits/childrens-logo_full_color_2021.webp",
  },

  // {
  //   id: 4,
  //   name: "CAPSA - Citizens Against Physical and Sexual Abuse",
  //   address: "PO Box 3617, Logan,\n UT 84323",
  //   contact: "435-753-2500",
  //   email: "info@capsa.org",
  //   website: "https://capsa.org",
  //   mission:
  //     "Safe shelter, advocacy, support for domestic violence/sexual assault victims; prevention",
  //   programs: "Shelter, mobile crisis team, education, outreach, confidential support",
  //   logo: "/img/nonprofits/capsaLogo.webp",
  // },
  // {
  //   id: 5,
  //   name: "Canyonlands Field Institute",
  //   address: "1320 South Hwy 191, Moab, UT 84532",
  //   contact: "435-259-7750",
  //   email: "info@cfimoab.org",
  //   website: "https://cfimoab.org",
  //   mission:
  //     "Outdoor education to inspire care for wild places on the Colorado Plateau",
  //   programs: "Educational rafting, field studies, adult trips, school/youth outreach",
  //   logo: "/img/nonprofits/CFI-Logo-Horizontal_1-2048x392.webp",
  // },

  // {
  //   id: 6,
  //   name: "Flourish Therapy, Inc.",
  //   address: "1422 E 820 N, Orem,\n UT 84097",
  //   contact: "385-309-1038",
  //   email: "info@flourishtherapy.org",
  //   website: "https://flourishtherapy.org",
  //   mission:
  //     "Culturally competent, affordable behavioral/mental health for LGBTQIA+ community",
  //   programs: "Individual, couples, family/group counseling, crisis intervention, remote and in-person",
  //   logo: "/img/nonprofits/Flourish+Logo.webp",
  // },
  // {
  //   id: 7,
  //   name: "HEAL Utah",
  //   address: " 824 S 400 W, Ste B111, Salt Lake City, UT 84101",
  //   contact: "801-355-5055",
  //   email: "info@healutah.org",
  //   website: "https://healutah.org",
  //   mission:
  //     "Protect Utah's environment and people: clean air, energy, solutions to toxic/radioactive waste",
  //   programs:
  //     "Education, grassroots advocacy, policy lobbying, clean energy outreach",
  //   logo: "/img/nonprofits/heal-final-1000px.webp",
  // },
  // {
  //   id: 8,
  //   name: "Project Connection",
  //   address: "2655 S. Lake Erie Drive, Suite B, West Valley City, UT 84120",
  //   contact: "(385) 441-4900",
  //   email: "intake@projectconnection.co",
  //   website: "https://projectconnection.co",
  //   mission:
  //     "Foster meaningful connections, reduce loneliness (social/emotional support focus)",
  //   programs: "Virtual/in-person community-building programs for campuses, workplaces",
  //   logo: "/img/nonprofits/PCLogo-H-White2x.webp",
  // },

  // {
  //   id: 9,
  //   name: "Friends of the Children - Utah",
  //   address: "5361 S 4220 W, Suite B, Kearns, UT 84118",
  //   contact: "385-474-8369",
  //   email: "info@friendsutah.org",
  //   website: "https://friendsutah.org",
  //   mission:
  //     "Generational change: empower youth facing greatest obstacles via professional mentors",
  //   programs:
  //     "Long-term mentorship-'Friends', support for youth through high school",
  //   logo: "/img/nonprofits/FOTC-Utah.webp",
  // },
  // {
  //   id: 10,
  //   name: "Wasatch Adaptive Sports",
  //   address: "9385 S Snowbird Center Dr., Snowbird, UT 84092",
  //   contact: "801-834-0476",
  //   email: "info@wasatchadaptivesports.org",
  //   website: "https://wasatchadaptivesports.org",
  //   mission:
  //     "Empower those with disabilities via outdoor recreation",
  //   programs: "Adaptive sports (skiing, cycling, kayaking etc.), scholarships, family-focused programs",
  //   logo: "/img/nonprofits/adaptive-sports.webp",
  // },
  // {
  //   id: 11,
  //   name: "Youth Futures Utah",
  //   address: "2760 Adams Ave., Ogden, UT 84403",
  //   contact: "801-528-1214",
  //   email: "info@yfut.org",
  //   website: "https://youthfuturesutah.org",
  //   mission: "Safe shelter, guidance, resources for homeless, runaway, at-risk youth",
  //   programs: "Shelters, drop-in centers, street outreach, case management",
  //   logo: "/img/nonprofits/GuidestarGoldSeal2021Web.webp",
  // },
  // {
  //   id: 12,
  //   name: "Habitat for Humanity — Greater Salt Lake Area",
  //   address: "1276 S 500 W, Salt Lake City, UT 84101",
  //   contact: "801-263-0136",
  //   email: "habitat@habitatsaltlake.org",
  //   website: "https://habitatsaltlake.org",
  //   mission: "Build homes, hope, community; affordable housing solutions",
  //   programs: "Affordable homeownership, critical repairs, Global Village, ReStore, neighborhood projects",
  //   logo: "/img/nonprofits/GreaterSaltLakeArea-Sgl-Black.webp",
  // },
];

const NonProfits = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
      {/* Landing Section */}
      <LandingSection
        data={{
          imageName: "nonprofits.webp",
          title: "Utah Nonprofits",
          visible: "",
        }}
      />

      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>Utah Nonprofit Organizations</h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              Utah is home to numerous nonprofit organizations dedicated to
              serving communities, protecting the environment, supporting
              vulnerable populations, and enhancing quality of life across the
              state. These organizations work tirelessly to address critical
              needs and create positive change.
            </p>
          </div>
        </div>
      </div>

      {/* Utah Nonprofits Association Logo Section */}
      {/* <div className="w-full bg-white py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-center text-gray-700 text-base sm:text-lg mb-6 font-medium">
            UTahData is a proud supporter of Utah Nonprofits Association (UNA), which works to unify, strengthen, and elevate UTah's nonprofit sector.
          </p>


          <div className="flex flex-col items-center justify-center bg-sky-200 rounded-xl p-8 shadow-md">
            <div className="mb-4">
              <Link
                to="/utah-at-a-glance/utah-nonprofits/dashboard"
                className="inline-block hover:opacity-80 transition-opacity"
              >
                <img
                  src="/img/nonprofits/utah-nonprofits-association-logo.png"
                  alt="Utah Nonprofits Association Logo"
                  className="h-24 sm:h-32 md:h-40 object-contain"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </Link>
            </div>

            <p className="text-center text-gray-600 text-sm sm:text-base max-w-2xl">
              Supporting and strengthening Utah&apos;s nonprofit sector through&nbsp;
              capacity-building training, resources, advocacy, and community.
            </p>
          </div>

        </div>
      </div> */}

      {/* Main Content */}
      <div className="flex-grow max-w-7xl mx-auto py-12 w-full px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          {/* <a
            href="https://members.utahnonprofits.org/nonprofit-member-directory"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mb-4 px-6 py-3 text-white font-bold text-lg sm:text-xl md:text-2xl rounded-full transition-all duration-300 shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] hover:shadow-[0_8px_24px_0_rgba(1,76,178,0.4)] hover:scale-105"
            style={{ backgroundColor: '#014cb2' }}
          >
            <span>Utah Nonprofit Organizations Directory</span>
            <ArrowUpRight size={20} strokeWidth={2.5} />
          </a> */}
          <div className="flex justify-center items-center px-4">
            <Link to="/utah-at-a-glance/utah-nonprofits/nonprofit-data-insights"
              className="block w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg mx-auto text-center"
            >
              <div className="w-full">
                <ActionButton data={"Utah Nonprofit\nData Insights"} />
              </div>
            </Link>
          </div>
          <br />
          <br />
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-2">
            Some key organizations making a difference in Utah
          </h1>
          <p className="text-sm text-gray-600 mt-4 italic">
            Note: There are 13,566 nonprofits in Utah as of the latest IRS data
            available.
          </p>
        </div>

        {/* Nonprofit Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-6">
          {nonprofits.map((nonprofit, index) => (
            <motion.div
              key={nonprofit.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.3 }}
              className="flex"
            >
              {/* Card Container */}
              <div className="bg-white rounded-xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden transition-all duration-300 hover:shadow-[0_8px_24px_0_rgba(1,76,178,0.4)] hover:scale-105 flex flex-col w-full h-full">
                {/* Logo Section */}
                <div className="bg-gradient-to-br from-slate-800 via-blue-700 to-blue-900 p-6 flex items-center justify-center h-[200px] flex-shrink-0 relative">
                  {/* Dark Sky Blue Card Background - optimized for blue, red, and white text from Utah Data logo */}
                  <div className="absolute inset-4 bg-[#366577] rounded-lg shadow-lg"></div>

                  {/* Logo Container */}
                  <div className="relative z-10 w-full h-full flex items-center justify-center">
                    {nonprofit.logo ? (
                      <img
                        src={nonprofit.logo}
                        alt={`${nonprofit.name} logo`}
                        className={`max-w-full max-h-32 object-contain relative z-10 ${nonprofit.name.includes("CAPSA") ? "mx-auto block" : ""}`}
                        style={nonprofit.name.includes("CAPSA") ? { margin: "0 auto", display: "block" } : {}}
                        onError={(e) => {
                          e.target.style.display = "none";
                          e.target.nextSibling.style.display = "flex";
                        }}
                      />
                    ) : (
                      <div className="flex items-center justify-center text-white font-semibold text-center px-4 relative z-10">
                        <div className="w-24 h-24 rounded-full bg-blue-600 flex items-center justify-center text-white text-2xl font-bold shadow-lg">
                          {nonprofit.name.charAt(0)}
                        </div>
                      </div>
                    )}
                    <div
                      className="hidden items-center justify-center text-white font-semibold text-center px-4 relative z-10"
                      style={{ display: "none" }}
                    >
                      {nonprofit.name}
                    </div>
                  </div>
                </div>

                {/* Content Section */}
                <div className="p-3 flex flex-col flex-grow">
                  {/* Organization Name */}
                  <h3 className="text-base font-bold text-blue-900 text-center mb-3 line-clamp-2 min-h-[52px] flex flex-col justify-center">
                    {nonprofit.name.split("\n").map((line, idx) => (
                      <span key={idx} className="block">
                        {line}
                      </span>
                    ))}
                  </h3>

                  {/* Details Blocks */}
                  <div className="space-y-2 flex-grow">
                    {/* Mission Block */}
                    <div className="bg-slate-50 rounded-lg p-3 min-h-[140px] flex items-start">
                      <p className="text-xs text-gray-700 leading-relaxed">
                        <span className="font-semibold text-blue-700">
                          Mission:
                        </span>{" "}
                        {nonprofit.mission}
                      </p>
                    </div>

                    {/* Programs Block */}
                    {nonprofit.programs && (
                      <div className="bg-slate-50 rounded-lg p-3 min-h-[140px] flex items-start">
                        <p className="text-xs text-gray-700 leading-relaxed">
                          <span className="font-semibold text-blue-700">
                            Programs:
                          </span>{"\u00A0"}
                          {nonprofit.programs}
                        </p>
                      </div>
                    )}

                    {/* Contact Block */}
                    <div className="bg-slate-50 rounded-lg p-3 space-y-1 min-h-[140px] flex flex-col justify-start">
                      {nonprofit.address && (
                        <div className="flex items-start gap-2">
                          <MapPin
                            className="flex-shrink-0 text-blue-600 mt-0.5"
                            size={14}
                          />
                          <p className="text-xs text-gray-600 leading-snug">
                            {nonprofit.address.split("\n").map((line, idx) => (
                              <span key={idx} className="block">
                                {line}
                              </span>
                            ))}
                          </p>
                        </div>
                      )}
                      {nonprofit.contact && (
                        <div className="flex items-center gap-2">
                          <Phone
                            className="flex-shrink-0 text-blue-600"
                            size={14}
                          />
                          <a
                            href={`tel:${nonprofit.contact}`}
                            className="text-xs text-blue-600 hover:text-blue-800 hover:underline"
                          >
                            {nonprofit.contact}
                          </a>
                        </div>
                      )}
                      {nonprofit.email && (
                        <div className="space-y-1">
                          {nonprofit.email.includes(',') && nonprofit.email.includes('@') ? (
                            // Multiple emails - parse and display separately
                            nonprofit.email.split(',').map((emailPart, idx) => {
                              // Extract email address from string like "Name (Title) - email@domain.com"
                              const emailMatch = emailPart.trim().match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/);
                              const emailAddr = emailMatch ? emailMatch[1] : emailPart.trim();
                              const displayText = emailPart.trim();

                              return (
                                <div key={idx} className="flex items-start gap-2">
                                  {idx === 0 && (
                                    <Mail
                                      className="flex-shrink-0 text-blue-600 mt-0.5"
                                      size={14}
                                    />
                                  )}
                                  {idx > 0 && (
                                    <div className="w-[14px] flex-shrink-0"></div>
                                  )}
                                  <a
                                    href={`mailto:${emailAddr}`}
                                    className="text-xs text-blue-600 hover:text-blue-800 hover:underline break-all"
                                  >
                                    {displayText}
                                  </a>
                                </div>
                              );
                            })
                          ) : (
                            // Single email - display normally
                            <div className="flex items-center gap-2">
                              <Mail
                                className="flex-shrink-0 text-blue-600"
                                size={14}
                              />
                              <a
                                href={`mailto:${nonprofit.email}`}
                                className="text-xs text-blue-600 hover:text-blue-800 hover:underline break-all"
                              >
                                {nonprofit.email}
                              </a>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Website Link */}
                  <div className="flex items-center justify-center gap-2 pt-2 border-t border-gray-200 mt-3">
                    <Globe2 className="text-blue-600" size={16} />
                    <a
                      href={nonprofit.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-800 hover:underline font-medium text-xs"
                    >
                      Visit Website
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default NonProfits;
